import React, { ReactNode, useContext } from "react";

export interface FeatureFlag {
  name: string;
  isActive: boolean;
}

export const FeatureFlags = React.createContext<FeatureFlag[]>([]);

interface FeatureFlagsProviderProps {
  children: ReactNode;
}

export class FeatureFlagsProvider extends React.Component<FeatureFlagsProviderProps> {
  render() {
    const { children } = this.props;
    const flags = buildFeatureFlags();

    return (
      <FeatureFlags.Provider value={flags}>{children}</FeatureFlags.Provider>
    );
  }
}

export function useFeature(name: string) {
  const flags = useContext(FeatureFlags);
  return flags.some((flag) => flag.name === name && flag.isActive);
}

export function buildFeatureFlags(): FeatureFlag[] {
  return [
    {
      name: "annotations",
      isActive: process.env.REACT_APP_READER_FEATURE_HIGHLIGHTS === "enabled",
    },
  ];
}
